import {
  StyleSheet,
  ImageBackground,
  useWindowDimensions,
  SafeAreaView,
} from "react-native";
import React from "react";

import { View, ScrollView, Heading, Text, Pressable } from "native-base";
import Card from "../../components/Card";
import { StackScreenProps } from "../../types";
import BottomSlidingImages from "../../components/BottomSlidingImages";
import Header from "../../components/Header";

const Production = ({ navigation }: StackScreenProps<"ResearchAndDev">) => {
  const { height, width } = useWindowDimensions();

  const data = [
    {
      heading: "Industrial Plants",
      subheading: "",
      details: "",
      iconName: "",
      onPress: () => navigation.navigate("ChemicalPlatform"),
      image: require("../../assets/factory-50.png"),
    },
    {
      heading: "Bulk Blending Plants",
      subheading: "$43.1Million Investment",
      details:
        "OCP Africa is currently deploying three ultra-modern bulk blending plants  in Kaduna, Ogun and Sokoto with a storage capacity of approximately  100,000MT and a blending capacity of  approximately 500,000MT per year.",
      iconName: "",
      onPress: () => navigation.navigate("BulkBlendingPlants"),
    },

    {
      heading: "Smart Blenders",
      subheading: "",
      details: "",
      iconName: "",
      onPress: () => navigation.navigate("SmartBlenders"),
      image: require("../../assets/vectors/blender.png"),
    },
  ];

  const partners = [
    { image: require("../../assets/partners/nsia.png"), name: "NSIA" },
    { image: require("../../assets/partners/springfield.png"), name: "NSIA" },
    {
      image: require("../../assets/partners/babban-gona.png"),
      name: "Babban Gona",
    },
    { image: require("../../assets/partners/iadr.png"), name: "" },
    { image: require("../../assets/partners/dangona.png"), name: "Dangona" },
  ];

  return (
    <ImageBackground
      source={require("../../assets/background.png")}
      resizeMode="repeat"
      style={{ width, height }}
    >
      <View style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <ScrollView
            px={5}
            contentContainerStyle={{
              justifyContent: "space-between",
              flex: 1,
            }}
          >
            <View>
              <Header
                onPress={() => navigation.navigate("Home")}
                headingText="Production"
                intro="In order to transform the lives of smallholder farmers, OCP Africa is investing strategic fertilizer production projects to provide affordable and crop specific fertilizers for improved yields and income of smallholder farmers."
              />

              {data.map((item) => (
                <Pressable key={item.heading} mb={10} onPress={item.onPress}>
                  <Card
                    heading={item.heading}
                    subheading={item.subheading}
                    details={item.details}
                    iconName={item.iconName}
                    onPress={item.onPress}
                    bg="rgba(158, 40, 66, 1)"
                    borderBottomColor="#999"
                    borderColor="#bbb"
                    image={item?.image}
                  />
                </Pressable>
              ))}
            </View>

            <BottomSlidingImages partners={partners} />
          </ScrollView>
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default Production;

const styles = StyleSheet.create({
  shadow: {
    shadowOffset: { width: 0, height: 20 },
    shadowRadius: 20,
    shadowOpacity: 0.6,
    shadowColor: "#000000",
    elevation: 20,
  },
  buttonShadow: {
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 1,
    shadowOpacity: 0.3,
    shadowColor: "#000000",
    elevation: 5,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "#860422a3",
  },
});
